import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeTopLevelSearch from "@saleor/hooks/makeTopLevelSearch";
import gql from "graphql-tag";

import { SearchCoupons, SearchCouponsVariables } from "./types/SearchCoupons";

export const searchCoupons = gql`
  ${pageInfoFragment}
  query SearchCoupons(
    $after: String
    $before: String
    $first: Int!
    $last: Int
    $sortBy: CouponSortingInput
    $query: String!
    $status: [CouponStatusEnum]
    $participatingMalls: [ID]
    $isAppliedToAllMalls: Boolean
  ) {
    search: coupons(
      after: $after
      before: $before
      first: $first
      last: $last
      sortBy: $sortBy
      filter: {
        searchName: $query
        status: $status
        participatingMalls: $participatingMalls
        isAppliedToAllMalls: $isAppliedToAllMalls
      }
    ) {
      edges {
        node {
          id
          name
          redeemType
          code
          status
          startDate
          endDate
          malls(first: $first) {
            edges {
              node {
                id
                name
              }
            }
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;

export default makeTopLevelSearch<SearchCoupons, SearchCouponsVariables>(
  searchCoupons
);
